// Generate unique ID - use crypto.randomUUID for browser support
export const generateId = (prefix: string): string => {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return `${prefix}-${crypto.randomUUID()}`;
    }
    // Fallback for older browsers
    return `${prefix}-${Math.random().toString(36).substring(2, 11)}`;
  };